var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepsMenu mt-4"},[_vm._l((_vm.tabMenu),function(tab,index){return [(index <= _vm.lastActiveStep || index <= _vm.currentStep)?[_c('div',{class:'active ' + _vm.style(index),on:{"click":function($event){return _vm.changeStep(index)}}},[_vm._v(_vm._s(tab))])]:[_c('div',[_vm._v(_vm._s(tab))])]]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1b61a7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/b122/stepsMenu.vue
// module id = y49p
// module chunks = 0